import { KnowledgeSourceAccordion } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/KnowledgeSourceAccordion/KnowledgeSourceAccordion';
import { AddItemIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIcon';
import { AddFreshdeskTicketsPopup } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/FreshdeskTicketsAccordion/AddFreshdeskTicketsPopup/AddFreshdeskTicketsPopup';
import type { KnowledgeBase, KnowledgeBaseCollector } from 'src/services/knowledgeBaseService';

export const FreshdeskTicketsAccordion = ({
  item = null,
  isButtonsDisabled = false,
  knowledgeBase,
}: {
  item?: KnowledgeBaseCollector | null;
  isButtonsDisabled?: boolean;
  knowledgeBase: Pick<KnowledgeBase, 'id'>;
}) => (
  <KnowledgeSourceAccordion
    item={item}
    isButtonsDisabled={isButtonsDisabled}
    knowledgeBase={knowledgeBase}
    icon={
      <div className={'pt-[3px]'}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
        >
          <g clipPath="url(#clip0_28642_18323)">
            <path
              d="M7.47655 0.0010372H13.11C13.3589 -0.000964776 13.6058 0.0466247 13.8361 0.141029C14.0665 0.235434 14.2757 0.374764 14.4516 0.550891C14.6276 0.727017 14.7667 0.936415 14.8608 1.16687C14.9549 1.39732 15.0023 1.64421 15 1.89315V7.52447C15 11.6546 11.6536 15.001 7.52343 15.001H7.48077C6.49867 15.0019 5.52603 14.8092 4.61845 14.4339C3.71086 14.0587 2.88613 13.5083 2.19138 12.8141C1.49664 12.12 0.945511 11.2957 0.5695 10.3884C0.19349 9.48116 -3.11713e-05 8.50868 3.76598e-09 7.52658C3.76598e-09 3.38471 3.34078 0.0436934 7.47655 0.0010372Z"
              fill="#05050D"
            />
            <path
              d="M7.49881 3.3418C5.60211 3.3418 4.06445 4.8793 4.06445 6.77633V9.11164C4.07805 9.73671 4.58146 10.2402 5.2065 10.2537H6.17794V7.57109H4.86551V6.82109C4.94519 5.40875 6.11396 4.30391 7.52881 4.30391C8.94366 4.30391 10.1096 5.40664 10.1893 6.82109V7.57109H8.85811V10.2556H9.7358V10.2983C9.72643 10.8781 9.25887 11.3459 8.68117 11.353H7.63286C7.54756 11.353 7.45381 11.3956 7.45381 11.4807C7.45587 11.5275 7.4754 11.5719 7.50854 11.605C7.54169 11.6382 7.58604 11.6577 7.63286 11.6598H8.6875C9.43863 11.6551 10.0463 11.0473 10.051 10.2962V10.2109C10.3019 10.1543 10.5259 10.0136 10.6856 9.81196C10.8453 9.61037 10.9311 9.36014 10.9287 9.10296V6.82109C10.9714 4.88656 9.43722 3.34391 7.49436 3.34391L7.49881 3.3418Z"
              fill="#F1F7F6"
            />
          </g>
          <defs>
            <clipPath id="clip0_28642_18323">
              <rect width="15" height="15" fill="white" transform="translate(0 0.000976562)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    }
    title={'Freshdesk tickets'}
    description={'Teach your AI from solved tickets'}
    addPopup={
      <AddFreshdeskTicketsPopup
        disabled={isButtonsDisabled}
        knowledgeBaseId={knowledgeBase.id}
        trigger={<AddItemIcon />}
      />
    }
  />
);
